<template>
    <v-container class="pa-0 ma-0" fluid>
      <v-row class="mb-0 pb-0">
        <v-col cols="10" md="6">
            <v-text-field
              label=""
              placeholder="Buscar..."
              @keyup.enter="search()"
              filled
              dense
              hide-details
              class="caption"
              ref="search"
            ></v-text-field>
        </v-col>
        <v-col cols="2" md="6" class="my-2">
          <v-btn  tile medium color="primary" icon @click.prevent="search()">
            <v-icon medium>fa-search</v-icon>
          </v-btn>          
        </v-col>
      </v-row>
			<v-row class="px-0 py-0">
				<v-col cols=12 >
          <v-data-table
            dense
            :headers="headers"
            :items="filtro"
            class="elevation-2"
            :hide-default-header="false"
            min-height="200px"
            height="500px"
            :fixed-header="true"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
            :disable-pagination='false'
            :loading="loadGrid"
            
          >
            <template v-slot:top>
              <v-toolbar flat dense color="white">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark class="mb-2" @click.stop="editItem({})">+</v-btn>
                <v-dialog v-model="dialog" width="80vw" scrollable persistent>
                  <Titulo 
                    :id="id"
                    @close="close()"
                    @reload="loadItems()"
                    :key="cOpen"
                  />
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item="{item,isMobile, headers} ">
              
              <DataGridBody :item="item" :headers="headers" :isMobile="isMobile" @edit-item="editItem" @delete-item="deleteItem" />
            </template>

          </v-data-table>
        </v-col>
        <v-col cols=12>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </v-col>

      </v-row>
      
    </v-container>
</template>
<script>
  import Titulo from '@/components/Archivos/Titulos/Titulo'
  import DataGridBody from '@/components/DataGridBody'

  import {mapGetters} from 'vuex'

  export default {
    name: 'Titulos',

    components: {
      Titulo,
      DataGridBody
    },

    data: () => ({
      dialog:false,
      cOpen:0,

      field:"",  //campo de busqueda
      loadGrid:false,



      headers: [
        { text: 'Descrip.' ,align: 'start',sortable: true, value: 'descripcion', type:'text'},
        { text: 'Tipo'   ,align: 'start',sortable: true, value: 'tipo', type:'text'},
        { text: 'Categorias'   ,align: 'start',sortable: true, value: 'categorias',class:"text-truncate",width:"250px", type:'text'},
        { text: ''       ,align: 'center'  ,sortable: false, value: 'actions', width:"85px",type:'actions' },
      ],
      items:[],

      id:0,

      page: 1,
      pageCount: 0,
      itemsPerPage: 100,


    }),
    created: function () {
      console.log("Componente creado")
    },
    mounted: function () {
      console.log("Componente mondado")
      this.loadItems()
    },
    watch: {
    },

    methods: {
      async initialize () {
      },

      close(){
        this.dialog=false
        this.id=0
        //this['_key']++
      },

      search(){
        //this.$refs.search.$refs.input.value ? 
        this.field=this.$refs.search.$refs.input.value
      },

      editItem (item) {
        console.log(item)
        this.cOpen++
        this.id=item.id || 0
        this.dialog = true
      },

      deleteItem (item) {
        confirm('Seguro que desea eliminar el dato seleccionado?') && this.delete(item.id)
      },

      async delete(id) {
        let opt={
          method: 'DELETE', 
          mode: 'cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },  
          //body: JSON.stringify(param),
        }
        let response = await fetch(`${this.ROOT_API}cms/titulos/${id}`, opt)
        
        await this.loadItems()
      },

      async loadItems (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}titulos`, opt);

        if (response.ok){
          let r=await response.json()
          this.items=r/*.map(item => {
            return item{
              id:item.id,
              codigo:item.codigo,
              des:item.des,
              precio:item.precio,
              estado:item.estado,
              marca:'',//item.marca
              categoria:''
            }
          })*/
        }

      }


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      filtro: function(){
        this.loadGrid=true
        let r=this.items.filter( item => item.descripcion.toLowerCase().includes(this.field.toLowerCase()) || item.categorias.toLowerCase().includes(this.field.toLowerCase()) || item.items.toLowerCase().includes(this.field.toLowerCase()) )
        this.loadGrid=false
        return r//((r && r.length>0)  ? r.map(function(i) { return parseFloat(i.importe) }).reduce((res, item) => res=res + item) : 0).toFixed(2)
      },
    },
  }
</script>

<style scoped>

</style>
